module.exports = __webpack_public_path__ + "static/media/GroupLogo.dede78fd.svg";